import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";

export const LoadingButton = ({
  isLoading,
  isError,
  children,
  ...props
}: React.ComponentProps<typeof Button> & {
  isLoading: boolean;
  isError?: boolean;
}) => {
  return (
    <Button
      type="submit"
      variant={isError ? "destructive" : "default"}
      {...props}
    >
      {isLoading && <Spinner data-icon="inline-start" />}
      {isError && <span>⚠️</span>}
      {!isLoading && !isError && children}
    </Button>
  );
};
